import { useIntl } from 'react-intl'

import BaseCompactCard from './BaseCompactCard'

import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { getNightOfText } from 'tripPlanner/utils'
import type { DetailItemCardVariant } from '../DetailItemCard/common/types'

interface Props {
  item: AccommodationItem
  presentationType: 'start' | 'end' | 'intermediary'
  date?: moment.Moment
  variant: DetailItemCardVariant
}

function CompactAccommodationCard({ item, presentationType, date, variant }: Props) {
  const timeFormat = useRegionTimeFormat()
  const intl = useIntl()

  let description: string | undefined
  if (presentationType === 'start') {
    description = 'Check-in'
    if (item.startTime) {
      description += ` at ${item.startTime.format(timeFormat)}`
    }
  } else if (presentationType === 'end') {
    if (item.endTime) {
      description = intl.formatMessage(
        {
          id: 'FJD0Sw1S7cuTLG1e5KMQ',
          defaultMessage: 'Check out at {time}',
          description: 'Check out time label with specific time for an accommodation item in the trip planner itinerary',
        },
        { time: item.endTime.format(timeFormat) },
      )
    } else {
      description = intl.formatMessage({
        id: 'TwsqWG_u-E9YFZLxsZSj',
        defaultMessage: 'Check out',
        description: 'Generic check out label without time for an accommodation item in the trip planner itinerary',
      })
    }
  } else if (presentationType === 'intermediary' && date) {
    description = getNightOfText(item, date)
  }
  return (
    <BaseCompactCard
      item={item}
      icon={<LineBedIcon size="S" />}
      title={item.place.name}
      description={description}
      isPrimary={presentationType === 'start'}
      variant={variant}
    />
  )
}

export default CompactAccommodationCard
